import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import sortQuestions from '../utils/sortQuestions';
import type {
  TuidVerifyState,
  TuidVerifyScreen,
  TuidVerifyOtpScreen,
  TuidVerifyQuestion,
  TuidVerifyAnswerCollection,
  VerifyMessage,
} from '../types';

const initialState: TuidVerifyState = {
  screen: 'INTRO',
  otpScreen: 'OPTIONS',
  questions: [],
  currentIndex: 0,
  collectedAnswers: [],
  verifyMessage: null,
  cooldownDays: null,
  showCooldown: false,
  sessionId: '',
  resendCount: 0,
  otpModeId: '',
  otpOptionId: '',
  otpDeliveryAnswerId: '',
};

const tuidVerifySlice = createAppSlice({
  name: 'tuidVerify',
  initialState,
  reducers: {
    resetFlow() {
      return initialState;
    },
    setSessionId(state, action: PayloadAction<string>) {
      state.sessionId = action.payload;
    },
    setScreen(state, action: PayloadAction<TuidVerifyScreen>) {
      state.screen = action.payload;
    },
    setOtpScreen(state, action: PayloadAction<TuidVerifyOtpScreen>) {
      state.otpScreen = action.payload;
    },
    setQuestions(state, action: PayloadAction<TuidVerifyQuestion[]>) {
      state.questions = sortQuestions(action.payload);
      state.currentIndex = 0;
    },
    nextQuestion(state, action: PayloadAction<TuidVerifyAnswerCollection>) {
      state.collectedAnswers.push(action.payload);
      state.currentIndex += 1;
    },
    setVerifyMessage(state, action: PayloadAction<VerifyMessage | null>) {
      state.verifyMessage = action.payload;
    },
    setCooldown(state, action: PayloadAction<{ days: number | null }>) {
      state.cooldownDays = action.payload.days;
      state.showCooldown = action.payload.days !== null;
    },
    setOtpMeta(
      state,
      action: PayloadAction<{ modeId: string; optionId: string }>,
    ) {
      state.otpModeId = action.payload.modeId;
      state.otpOptionId = action.payload.optionId;
    },
    setOtpDeliveryAnswerId(state, action: PayloadAction<string>) {
      state.otpDeliveryAnswerId = action.payload;
    },
    incrementResend(state) {
      state.resendCount += 1;
    },
    resetCollectedAnswers(state) {
      state.collectedAnswers = [];
      state.currentIndex = 0;
    },
  },
});

export const {
  resetFlow,
  setSessionId,
  setScreen,
  setOtpScreen,
  setQuestions,
  nextQuestion,
  setVerifyMessage,
  setCooldown,
  setOtpMeta,
  setOtpDeliveryAnswerId,
  incrementResend,
  resetCollectedAnswers,
} = tuidVerifySlice.actions;

export default tuidVerifySlice.reducer;
